import { p as W, a as C, P as H, D as T, b as U, S as g } from "./pulldown-trigger-B2Xvufnc.mjs";
import { j as l } from "./jsx-runtime-DmTjM30f.mjs";
import { useState as q, useRef as z, useCallback as A, useEffect as F } from "react";
import { c as f } from "./tw-cn-mXgPecoF.mjs";
const G = ({
  children: m,
  value: p,
  isOpen: a,
  defaultOpen: d = !1,
  onOpenChange: e,
  placeholder: x = "선택해 주세요",
  triggerClassName: v,
  triggerContentClassName: w,
  contentClassName: D,
  wrapperClassName: S,
  disabled: n,
  isClosable: s = !1,
  isAccent: j = !1,
  needDisabledAccent: k,
  hasDivider: E
}) => {
  const [N, P] = q(d), r = a !== void 0, t = r ? a : N, i = z(null), R = W({ isOpen: t, disabled: n }), y = C({ isOpen: t }), c = A(
    (o) => {
      n || !s && t || (r ? e == null || e(o) : P(o));
    },
    [t, e, n, s, r]
  );
  return F(() => {
    if (!t || !s) return;
    const o = i.current, u = (B) => {
      const L = B.target;
      o.contains(L) || c(!1);
    };
    return document.addEventListener("click", u), () => {
      document.removeEventListener("click", u);
    };
  }, [t, s, c]), /* @__PURE__ */ l.jsxs("div", { className: f(R, S), ref: i, children: [
    /* @__PURE__ */ l.jsx(
      H,
      {
        className: v,
        hasDivider: E,
        isAccent: j,
        isDisabled: n,
        isOpen: t,
        needDisabledAccent: k,
        onClick: () => {
          c(!t);
        },
        placeholder: x,
        textClassName: w,
        value: p
      }
    ),
    t ? /* @__PURE__ */ l.jsx("div", { className: f(y, D), children: m }) : null
  ] });
}, Q = { Dropdown: T, DropdownOption: U, Button: g, PullDown: G };
export {
  Q as Selectbox
};
